export const filtersConfig = [
  {
    type: 'radioGroup',
    label: 'Dashboard::Choose period',
    value: 'past12Months',
    defaultValue: 'past12Months',
    key: 'periods',
  },
  {
    type: 'select',
    label: 'Dashboard::Select Risk Category',
    placeholder: 'Dashboard::Select Risk Category',
    key: 'riskCategory',
    optionsName: 'riskCategory',
  },
  {
    type: 'select',
    label: 'Select Risk Type',
    placeholder: 'Select Risk Type',
    key: 'riskType',
    optionsName: 'riskType',
  },
];

export const data = {
  periods: [
    {
      label: 'Dashboard::Past Month',
      value: 'pastMonth',
    },
    {
      label: 'Dashboard::3 Months',
      value: 'past3Months',
    },
    {
      label: 'Dashboard::12 Months',
      value: 'past12Months',
    },
  ],
};
